import { useCallback } from 'react';
import { useAudioStore } from '@/store/audioStore';
import { audioEngine } from '@/lib/audio/AudioEngine';
import type { CueId } from '@/lib/audio/types';

const CAN_HOVER = typeof window !== 'undefined' && window.matchMedia('(hover: hover)').matches;

export function useSound() {
    const { mode, hapticsEnabled } = useAudioStore();

    const play = useCallback((cue: CueId) => {
        if (mode === 'silent') return;

        // Desktop-only hover sounds
        if (cue === 'ui_hover' && !CAN_HOVER) return;

        // Minimal mode: only training-critical cues
        if (mode === 'minimal') {
            const allowed: CueId[] = [
                'count_5', 'count_4', 'count_3', 'count_2', 'count_1',
                'whistle', 'wrestle', 'begin', 'buzzer', 'time', 'rest_start', 'rest', 'transition', 'complete', 'break',
            ];
            if (!allowed.includes(cue)) return;
        }

        // Haptics
        if (hapticsEnabled && navigator.vibrate) {
            if (cue === 'ui_press' || cue === 'ui_tap') navigator.vibrate(10);
            if (cue === 'whistle') navigator.vibrate([50, 50, 50]);
            if (cue === 'buzzer') navigator.vibrate([80, 40, 80]);
            if (cue === 'ui_error') navigator.vibrate([30, 30, 30]);
        }

        audioEngine.playCue(cue);
    }, [mode, hapticsEnabled]);

    return { play };
}
